'use strict';
const  when = require('when');
const Immutable = require('immutable');
const { CALL_JSONAPI } = require('../middleware/jsonapi');
const {
	programListFiltersSelector,
	programListCategoriesSelector,
	autoCompleteSelector
} = require('../selectors');

export const RESOURCE_REQUEST = 'RESOURCE_REQUEST';
export const RESOURCE_SUCCESS = 'RESOURCE_SUCCESS';
export const RESOURCE_FAILURE = 'RESOURCE_FAILURE';
export const RESOURCE_DISPLAY = 'RESOURCE_DISPLAY';

export const PROGRAM_LIST_FILTER = 'PROGRAM_LIST_FILTER';
export const PROGRAM_LIST_CATEGORIZE = 'PROGRAM_LIST_CATEGORIZE';
export const AUTO_COMPLETE_UPDATE_QUERY = 'AUTO_COMPLETE_UPDATE_QUERY';
export const AUTO_COMPLETE_UPDATE_SELECTION = 'AUTO_COMPLETE_UPDATE_SELECTION';
export const CLIENT_INITIALIZE = 'CLIENT_INITIALIZE';
export const LOCATION_UPDATE = 'LOCATION_UPDATE';


function shouldFetchResource(state, type, id) {
	const resource = state.getIn(['resources',`/${type}/${id}`], Immutable.Map());
	if (resource.isEmpty()) {
		return true;
	} else if (resource.get('isFetching', false)) {
		return false;
	} else {
		return false;
	}
}

function fetchResource(endpoint, include) {
	return {
		[CALL_JSONAPI]: {
			types: [RESOURCE_REQUEST, RESOURCE_SUCCESS, RESOURCE_FAILURE],
			endpoint: endpoint,
			includes: include
		}
	};
}

function shouldDisplayResource(state, type, id) {
	const resource = state.getIn(['selectedResource']);
	if(!resource) {
		return true;
	} else if (resource === `/${type}/${id}`) {
		return false;
	} else {
		return true;
	}
}
function displayResource(type, id) {
	return {
			type: RESOURCE_DISPLAY,
			endpoint: `/${type}/${id}`
	};
}

export function initializeClient() {
	return {
		type: CLIENT_INITIALIZE
	};
}

export function loadNotFoundPage(location, params) {
	return (dispatch, getState) => {
		const resource = getState().getIn(['selectedResource']);
		const endpoint = location.pathname;
		
		if(resource === endpoint) {
			return;
		}

		dispatch({
			type: RESOURCE_DISPLAY,
			endpoint: endpoint
		});

		return dispatch({
			type: RESOURCE_FAILURE,
			endpoint: endpoint,
			includes: [],
			error: { status:'404', message:'no route matched' } 
		});
	};
}

export function loadFirstpage() {
	const type = 'pages';
	const id = 'frontpage';
	const include = Object.freeze([
		'news',
		'editorials',
		'news.teasers',
		'news.teasers.cover',
		'editorials.teasers',
		'editorials.teasers.cover',
		'urgent_news',
		'urgent_news.top_teasers',
		'urgent_news.top_teasers.cover',
		'urgent_news.teasers',
		'urgent_news.teasers.cover'
	]);

	return (dispatch, getState) => {
		
		if(shouldDisplayResource(getState(), type, id)) {
			dispatch(displayResource(type, id));
		}

		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include));
		} else {
			return when.resolve();
		}

	};
}

export function loadFirstpageEditorials() {
	const type = 'teaser_lists';
	const id = 'frontpage_editorials';
	const include = Object.freeze([
		'teasers',
		'teasers.cover'
	]);

	return (dispatch, getState) => {
		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include));
		} else {
			return when.resolve();
		}
	};
}

export function loadArticlepage(location, params) {
	const type = 'articles';
	const id = params.article;
	const include = Object.freeze([
		'clips',
		'clips.picture',
		'cover',
		'program',
		'program.episodes',
		'program.episodes.cover'
	]);

	return (dispatch, getState) => {
		if(shouldDisplayResource(getState(), type, id)) {
			dispatch(displayResource(type, id));
		}
		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include));
		} else {
			return when.resolve();
		}
	};
}

export function loadProgrampage(location, params) {
	const type = 'programs';
	const id = params.program;
	const include = Object.freeze([
		'cover',
		'episodes',
		'episodes.cover',
		'creditlist',
		'character',
		'articles',
		'articles.cover'
	]);

	return (dispatch, getState) => {
		if(shouldDisplayResource(getState(), type, id)) {
			dispatch(displayResource(type, id));
		}
		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include));
		} else {
			return when.resolve();
		}
	};
}

export function loadImportantMessages() {
	const type = 'message_lists';
	const id = 'important';
	const include = Object.freeze([
		'messages'
	]);

	return (dispatch, getState) => {
		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include));
		} else {
			return when.resolve();
		}
	};
}

export function loadAutoComplete() {
	const type = 'program_lists';
	const id = 'programs_all';
	const include = Object.freeze([]);
	return (dispatch, getState) => {
		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include));
		} else {
			return when.resolve();
		}
	};
}

export function loadProgramListPage(location) {
	const type = 'pages';
	const id = 'programs';
	const include = Object.freeze([
			'program_editorials',
			'program_editorials.teasers',
			'program_editorials.teasers.cover',
			'program_list'
	]);
	
	var categories = (location && location.query && location.query.kategori)? location.query.kategori.split(',') : [];
	var filters = (location && location.query && location.query.filter)?location.query.filter.split(',') : [];
	
	if(location && location.query && location.query.kategori) {
		categories =  location.query.kategori.split(',');
	}
	if(location && location.query && location.query.filter) {
		filters =  location.query.filter.split(',');
	}
	
	const categoryList = Immutable.List((Object.keys(categories).length === 0)?[] : categories);
	const filterList = Immutable.fromJS((Object.keys(filters).length === 0)?['aktuella'] : filters);
	
	return (dispatch, getState) => {
		if(shouldDisplayResource(getState(), type, id)) {
			dispatch(displayResource(type, id));
		}
		if(shouldFetchResource(getState(), type, id)) {
			return dispatch(fetchResource(`/${type}/${id}`, include))
				.then(() => {
					dispatch(filterProgramList(filterList));
					dispatch(categorizeProgramList(categoryList));
					return when.resolve();
				});
		} else {
			dispatch(filterProgramList(filterList));
			dispatch(categorizeProgramList(categoryList));
			return when.resolve();
		}
	};
}

function hasLocationChanged(state, nextLocation) {
	const currentLoaction = state.getIn(['router','location'], Immutable.Map());
	return !Immutable.is(currentLoaction, nextLocation);
}

export function updateLocation(location) {
	return (dispatch, getState) => {

		const map = Immutable.fromJS({
									pathname: location.pathname,
									query: location.query	
								});

		if(hasLocationChanged(getState(), map)) {
			return dispatch({
				type: LOCATION_UPDATE,
				location: map
			});
		}
	};
}

///////////////////////////////////////
// AUTO COMPLETE 
///////////////////////////////////////
// TODO: Wrap these in one function
export function hideAutoComplete() {
	return (dispatch, getState) => {
		dispatch({
			type: AUTO_COMPLETE_UPDATE_SELECTION,
			index: undefined
		});
		dispatch({
			type: AUTO_COMPLETE_UPDATE_QUERY,
			query: ''
		});

	};
}

export function clearAutoCompleteSelection() {
	return (dispatch, getState) => {
		dispatch({
			type: AUTO_COMPLETE_UPDATE_SELECTION,
			index: undefined
		});

		dispatch({
			type: AUTO_COMPLETE_UPDATE_QUERY,
			query: ''
		});
	};
}

export function updateAutoCompleteQuery(value = '') {
	return (dispatch, getState) => {
		dispatch({
			type: AUTO_COMPLETE_UPDATE_SELECTION,
			index: undefined
		});

		dispatch({
			type: AUTO_COMPLETE_UPDATE_QUERY,
			query: value
		});
	};
}

export function updateAutoCompleteSelection(delta = 0) {
	return (dispatch, getState) => {
		const count = autoCompleteSelector(getState()).get('count', 0) + 1;
		let index = getState().getIn(['auto_complete', 'meta', 'index'], -1) + delta;
		if (index >= count) { 
			index = 0; 
		} else if (index < 0) { 
			index = count - 1; 
		}
		return dispatch({
			type: AUTO_COMPLETE_UPDATE_SELECTION,
			index: index
		});
	};
}

export function filterProgramList(filters) {
	return (dispatch, getState) => {
		if (Immutable.is(filters, programListFiltersSelector(getState()))) {
			return null;
		}
		return dispatch({
			type:PROGRAM_LIST_FILTER,
			data: filters
		});
	};
}

export function categorizeProgramList(categories) {
	return (dispatch, getState) => {
		if (Immutable.is(categories, programListCategoriesSelector(getState()))) {
			return null;
		}
		return dispatch({
			type:PROGRAM_LIST_CATEGORIZE,
			data: categories
		});
	};
}




/** WEBPACK FOOTER **
 ** ./app/actions/index.js
 **/